<div class="main">

</div>
<ng-template #ackDialog>
  <div class="dialogMain">
    <div class="section">
      <div class="header">
        <div class="label">
          <span>
            {{ "ACK.ackAlert" | translate }} {{ackType}}
          </span>
        </div>
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="bodySection">
        <div class="top">
           <div class="title">{{ "ACK.ackFor" | translate }} {{regNo}} -</div>
<mat-button-toggle-group class="group">
  <mat-button-toggle class="hourButton" (click)="setAckTime(1);">{{ "ACK.1hour" | translate }}</mat-button-toggle>
  <mat-button-toggle class="hourButton" (click)="setAckTime(6);">{{ "ACK.6hour" | translate }}</mat-button-toggle>
  <mat-button-toggle class="hourButton" (click)="setAckTime(12);">{{ "ACK.12hour" | translate }}</mat-button-toggle>
  <mat-button-toggle class="hourButton" (click)="setAckTime(24);">{{ "ACK.24hour" | translate }}</mat-button-toggle>
</mat-button-toggle-group>


        </div>
        <div class="bottom">
            <div class="button" style="border: solid 1px #114ab3;
    color: #631D4F; cursor: pointer;" (click)="acknowledge();">
                <div class="label">
                    {{ "ACK.submit" | translate }}
                </div>
            </div>
            <div class="button" style="border: solid 1px #a2a2a2;
    color: #aeaeae; cursor: pointer;" (click)="closeDialog();">
                <div class="label">
                    {{ "ACK.cancel" | translate }}
                </div>
            </div>

        </div>
      </div>
    </div>
  </div>
</ng-template>